module.exports = __webpack_public_path__ + "static/media/jane_signature.453f46fc.jpg";